import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteMaterial as deleteMaterialApi } from "../../../../services/dashboard/apiLecture";

export function useDeleteMaterial() {
  const queryClient = useQueryClient();

  const {
    mutate: deleteMaterial,
    isLoading: isDeleting,
    error,
  } = useMutation({
    mutationFn: deleteMaterialApi,
    onSuccess: () => {
      toast.success("تم حذف الملف بنجاح");

      queryClient.invalidateQueries({
        queryKey: ["lectureMaterials"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { deleteMaterial, isDeleting, error };
}
